<template>
    <el-drawer
        title="编辑配置"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="40%"
        :before-close="close">
         <div class="panel fx-g1" >
            <div class="tc">
                <!-- <el-row>
                    <el-form ref="form"  label-width="105px">
                        <el-form-item label="选项">
                            <el-select v-model="schoolType" placeholder="选项"  @change="changeOptions" style="margin-left:-400px;">
                                <el-option label="平台" :value="true"></el-option>
                                <el-option label="学校" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-row> -->
                <el-transfer
                    style="text-align: left; display: inline-block"
                    filterable
                    target-order="push"
                    :titles="['可选配置', '已选配置']"
                    :props="{
                        key: 'id',
                        label: 'name'
                    }"
                    :filter-method="filterLesson"
                    filter-placeholder="请输入配置名称"
                    v-model="choosedConfigs"
                    :data="configs">
                </el-transfer>
            </div>
        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">保 存</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>
<style scoped>
</style>
<script>
    export default {
        props: [
            "item",
        ],
        components: {
        },
        data() {
            return {
                show: false,
                type: this.item,
                form: {},
                showLoading: false,
                choosedConfigs: [],
                configs: [],
                needRefreshParent: false, //是否需要刷新父页面
                //schoolType: false,//true 是平台 false 是学校
            }
        },
        methods: {
            sub() {
                if(this.type == 3){
                    this.$ajaxPost("/trainConfig/saveByModule", {
                        schoolType: false,
                        linkIds: this.choosedConfigs
                    }, (data) => {
                        this.$emit("submit", data.result);
                        this.showLoading = false;
                        this.needRefreshParent = true;
                        this.$showSuccess("保存成功");
                    })
                }else{
                    this.$ajaxPost("/trainConfig/save", {
                        type: this.type,
                        linkIds: this.choosedConfigs
                    }, (data) => {
                        this.$emit("submit", data.result);
                        this.showLoading = false;
                        this.needRefreshParent = true;
                        this.$showSuccess("保存成功");
                    })
                }

            },
            filterLesson(query, item) {
                return item.name.indexOf(query) > -1;
            },
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            changeOptions() {
                this.loadConfig();
                this.loadLinkConfig();
            },
            loadConfig() {
                if (this.type) {
                    if(this.type == 3){ //模块
                        this.$ajaxGet("/trainConfig/listByModule/false", (data) => {
                            this.choosedConfigs = data.result.map(item => item.id);
                            return;
                        })
                        return;
                    }
                    this.$ajaxGet("/trainConfig/listByChoose/" + this.type, (data) => {
                        this.choosedConfigs = data.result.map(item => item.id);
                        return;
                    })
                } else {
                    this.choosedConfigs = [];
                }
            },
            loadLinkConfig() {
                if (this.type) {
                    if(this.type == 3){ //模块
                        this.$ajaxGet("/trainModule/listBySchoolType/false", (data) => {
                            this.configs = data.result;
                        })
                        return;
                    }
                    this.$ajaxGet("/trainCategory/listOptionByAll/"+this.type, (data) => {
                        this.configs = data.result;
                    })
                } else {
                    this.configs = [];
                }
            }
        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadConfig();
            this.loadLinkConfig();
        }
    }
</script>
